export default "__VITE_ASSET__BppkNwPb__"